import React, { createContext, useContext, useState } from 'react';

// Create the context
const FeeSettingsExpendedContext = createContext(undefined);

const FeeSettingsExpendedProvider = ({ children }) => {
  const [feeSettingsExpanded, setFeeSettingsExpanded] = useState(false);

  return (
    <FeeSettingsExpendedContext.Provider value={[feeSettingsExpanded, setFeeSettingsExpanded]}>
      {children}
    </FeeSettingsExpendedContext.Provider>
  );
};

const useFeeSettingsExpended = () => {
  const context = useContext(FeeSettingsExpendedContext);
  if (context === undefined) {
    throw new Error('useFeeSettingsExpended must be used within a FeeSettingsExpendedProvider');
  }
  return context;
};

export { FeeSettingsExpendedProvider, useFeeSettingsExpended };
